module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-1-100.3ada53bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-de-trabajo-1-100.jpg
// module id = 145
// module chunks = 0